import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { CASH_BOX_PAYOUT_LOOKUP_API, OVERPAYMENT_API, OVERPAYMENT_REASON_LOOKUP_API } from './consts'
import { CashBoxLookupItem, OverpaymentRecord, OverpaymentReasonLookupItem } from './response.types'
import { CreateOverpaymentRequest, PayViaLocalAdapterRequest } from './requests.types'
import { OverpaymentQuery } from './query.types'
import { OverpaymentFilters } from './types'

interface ApiResponse<T> {
  success: boolean
  data: T | null
  totalRows?: number
  errors?: Record<string, string>
}

export const getOverpaymentReasonLookup = () =>
  axios.get<ApiResponse<OverpaymentReasonLookupItem[]>>(`${API_URL}${OVERPAYMENT_REASON_LOOKUP_API}`)

export const createOverpayment = (body: CreateOverpaymentRequest) =>
  axios.post<ApiResponse<OverpaymentRecord>>(`${API_URL}${OVERPAYMENT_API}`, body)

/**
 * Выгрузка журнала: тот же фильтр, что и у списка, но без страницы — файл содержит всю выборку.
 */
export const exportOverpaymentList = (params: OverpaymentFilters) =>
  axios.get<Blob>(`${API_URL}${OVERPAYMENT_API}/list`, {
    params: { ...params, xlsx: true },
    responseType: 'blob',
  })

export const getOverpaymentList = (params: OverpaymentQuery) =>
  axios.get<ApiResponse<OverpaymentRecord[]>>(`${API_URL}${OVERPAYMENT_API}/list`, { params })

export const getPayoutCashBoxLookup = () =>
  axios.get<ApiResponse<CashBoxLookupItem[]>>(`${API_URL}${CASH_BOX_PAYOUT_LOOKUP_API}`)

export const payOverpaymentViaLocalAdapter = (id: number, body: PayViaLocalAdapterRequest) =>
  axios.post<ApiResponse<OverpaymentRecord>>(
    `${API_URL}${OVERPAYMENT_API}/${id}/pay-via-local-adapter`,
    body
  )
